import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import DataTable from "react-data-table-component";
import { downloadFile } from "services/ConfigServices";
import { energyData } from "variables/lists/bills";
import { dico } from "variables/lists/dico";
import {
  TextInput,
} from "components/Input/Index.js";

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;



function ViewDataListDialog(props) {
  const { closeModal, variable } = props;
  const classes = useStyles();

  const columns = [
    {
      name: "Id",
      selector: (row) => row.id,
      sortable: true,
      maxWidth: "9rem",
      cell: (row) =>
        <div>
          <TextInput
            inputTitle={""}
            textInput={row.id}
            handleTextInputChange={(e) => row.id = e.target.value}
          />
        </div>
    },
    {
      name: "Nom",
      selector: (row) => row.name,
      sortable: true,
    }
  ];

  return (
    <>
      <form className={classes.root}>
        {variable &&
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <Container>
                <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
                  dense
                  noDataComponent={<NoData>Aucune donnée à afficher</NoData>}
                  noHeader={true}
                  columns={columns}
                  persistTableHead
                  data={variable.data}
                />
              </Container>
            </GridItem>
          </GridContainer>}
      </form>
    </>
  );
}

export default ViewDataListDialog;
